import { Checkbox, Flex, Form } from 'antd'
import { Controller, FieldErrors } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { ErrorMessage } from '@hookform/error-message'
import Typography from 'antd/es/typography/Typography'
import { CheckboxChangeEvent } from 'antd/es/checkbox'
import { getModulesSetup } from 'src/app/store/userRoleSetup'
import { IModule } from 'src/app/shared/models/store.model'
import { FormCheckboxGroup } from './CheckboxGroup'
import { colorBgErrorBold, colorTextGray1 } from 'src/app/themes/primaryThemeDefault'
import { getActiveAll } from 'src/app/shared/utils'
import {
  EXCLUDED_NAVIGATION_SUBMODULES,
  SUPER_ADMIN_ONLY_NAVIGATION_SUBMODULES,
} from 'src/app/shared/models/roleAndPermission.model'
import { useParams } from 'react-router-dom'
import { UserRoleIds } from 'src/app/shared/constants/app.constants'
import './index.scss'

interface INavigationOptions {
  control: any
  errors?: FieldErrors<any>
  getValues?: any
  setValue?: any
  navigationOptionsWatch?: any
  trigger: any
}

const NavigationOptions = (props: INavigationOptions) => {
  const { t } = useTranslation()

  const modules = useSelector(getModulesSetup)
  const { id } = useParams()
  const { control, errors, setValue, navigationOptionsWatch, trigger } = props

  const isSuperAdminRole = id?.toLowerCase() === UserRoleIds.SUPER_ADMIN.toLowerCase()
  const excludedSubmodules = isSuperAdminRole
    ? EXCLUDED_NAVIGATION_SUBMODULES
    : [...EXCLUDED_NAVIGATION_SUBMODULES, ...SUPER_ADMIN_ONLY_NAVIGATION_SUBMODULES]

  const filteredModules = modules?.map((module: IModule) => ({
    ...module,
    submoduleItemShortInfos: module.submoduleItemShortInfos.filter(
      (submodule) => !excludedSubmodules.includes(submodule.submoduleItemName)
    )
  })).filter((module: IModule) => module.submoduleItemShortInfos.length > 0)

  const handleCheckOnchange = (e: CheckboxChangeEvent, field: any) => {
    field.onChange(e)
    if (e.target.checked) {
      setValue('navigationOptions', getActiveAll(filteredModules))
    } else {
      setValue('navigationOptions', [])
    }
    trigger('navigationOptions')
  }

  const handleCheckselectAllNavigations = (e: any) => {
    if (e.length === getActiveAll(filteredModules)?.length) {
      setValue('selectAllNavigations', true)
    } else {
      setValue('selectAllNavigations', false)
    }
  }

  return (
    <Flex vertical>
      <Flex justify='space-between' align='center'>
        <Form.Item
          label={t('UserRoles:navigationOptions')}
          className='isRequired label16'
          style={{ height: 22, margin: 0, flex: 1 }}
        />

        <Controller
          name='selectAllNavigations'
          control={control}
          render={({ field }) => (
            <Checkbox
              {...field}
              checked={field.value}
              onChange={(e: CheckboxChangeEvent) => {
                handleCheckOnchange(e, field)
              }}
            >
              {t('UserRoles:selectAllNavigations')}
            </Checkbox>
          )}
        />
      </Flex>

      <Flex
        vertical
        style={{
          padding: '8px 0px',
          margin: '12px 0px 0px',
          border: errors?.navigationOptions ? `1px solid ${colorBgErrorBold} ` : `1px solid ${colorTextGray1} `,
          borderRadius: '16px',
        }}
      >
        <Flex
          vertical
          style={{
            padding: '0px 24px',
            overflowY: 'scroll',
            height: 436,
          }}
        >
          <FormCheckboxGroup
            control={control}
            options={filteredModules?.toSorted((a: IModule, b: IModule) => a?.moduleItemOrderIndex - b?.moduleItemOrderIndex)}
            name={`navigationOptions`}
            keyElement={`navigationOptions`}
            value={navigationOptionsWatch}
            handleChange={(e) => {
              handleCheckselectAllNavigations(e)
            }}
          />
        </Flex>
      </Flex>
      <Flex vertical style={{ marginBottom: 24 }}>
        <Typography className='error-message'>
          <ErrorMessage errors={errors} name='navigationOptions' />
        </Typography>
      </Flex>
    </Flex>
  )
}

export default NavigationOptions
